import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { MAILING_API } from '@Constants/backendConstants';
import {
    emailCategoryOptions,
    emailStateOptions,
    type EnumEmailCategory,
    type EnumEmailState,
    getEnumEmailCategoryLabel,
    getEnumEmailStateLabel,
} from '@Model';
import { ApiEmailStatus, EnumFrontendLayoutSetting } from '@Model';
import { type Column } from '@synqo/frontend-component-library';
import { useListApi } from '@Hooks/useListApi';
import { EmailStatusRepository } from '@Repositories/Mailing';

const emailStatusColumns: Column<ApiEmailStatus>[] = [
    {
        name: 'category',
        label: 'Kategorie',
        filterVariant: 'select',
        filterOptions: emailCategoryOptions,
        renderCell: ({ cellData }) => getEnumEmailCategoryLabel(cellData as EnumEmailCategory),
    },
    { name: 'sending_date', label: 'Datum', type: 'datetime' },
    { name: 'subject', label: 'Betreff' },
    { name: 'sender', label: 'Sender' },
    { name: 'recipient', label: 'Empfänger' },
    {
        name: 'email_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: emailStateOptions,
        renderCell: ({ cellData }) => getEnumEmailStateLabel(cellData as EnumEmailState),
    },
];

export function FrameListEmailStatus() {
    const module = useListApi(EmailStatusRepository, MAILING_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiEmailStatus>
            layoutSettingsContext={EnumFrontendLayoutSetting.EmailStatusesTableLayout}
            name="EmailStatusList"
            columns={emailStatusColumns}
            loader={module.loadPage}
            canCreate={false}
            fullSize
        />
    );
}
